import { Stack } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { FormAwareButtonGroup } from '@/components/form/formAwareInputs/FormAwareButtonGroup';
import { Card } from '@/components/layout/Card/Card';
import { useFormContext } from '@/components/react-hook-form';

import {
  HypotheticalSaleLoanFormPaths,
  HypotheticalSaleLoanFormShape,
} from '../../EstateWaterfallHypotheticalSaleLoanModal.types';
import { useSaleLoanFormContext } from '../../Form/context/SaleLoanForm.context';
import { SaleLoanIllustrationGrowthSchedule } from './SaleLoanIllustrationGrowthSchedule';
import { SaleLoanIllustrationPaymentSchedule } from './SaleLoanIllustrationPaymentSchedule';

export function SaleLoanIllustrationDetails() {
  const { simulatedWaterfall: waterfall } = useSaleLoanFormContext();
  const { control } = useFormContext<HypotheticalSaleLoanFormShape>();
  const scheduleDisplayType = useWatch({
    control,
    name: 'scheduleDisplayType',
  });

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <FormAwareButtonGroup
          label="Schedule display type"
          hideLabel
          control={control}
          options={[
            { value: 'paymentSchedule', display: 'Payment schedule' },
            {
              value: 'projectedGrowth',
              display: 'Projected growth',
            },
          ]}
          fieldName={
            'scheduleDisplayType' as const satisfies HypotheticalSaleLoanFormPaths
          }
        />
        {scheduleDisplayType === 'paymentSchedule' && (
          <SaleLoanIllustrationPaymentSchedule waterfall={waterfall} />
        )}
        {scheduleDisplayType === 'projectedGrowth' && (
          <SaleLoanIllustrationGrowthSchedule waterfall={waterfall} />
        )}
      </Stack>
    </Card>
  );
}
